import { cva, type VariantProps } from 'class-variance-authority'

export { default as Avatar } from './Avatar.vue'
export { default as AvatarImage } from './AvatarImage.vue'
export { default as AvatarFallback } from './AvatarFallback.vue'

export const avatarVariants = cva('relative inline-flex shrink-0 rounded-avatar', {
  variants: {
    size: {
      lg: 'h-12 w-12',
      xl: 'h-14 w-14',
      '2xl': 'h-16 w-16',
      '3xl': 'h-32 w-32',
      '4xl': 'h-40 w-40',
      ctt: 'h-16 w-16 md:h-24 md:w-24'
    },
    variant: {
      image: 'border-2 border-avatar'
    }
  },
  defaultVariants: {
    size: 'xl',
    variant: 'image'
  }
})

export type AvatarProps = VariantProps<typeof avatarVariants>

export const avatarFallbackVariants = cva('flex h-full w-full items-center justify-center bg-aside text-aside-foreground uppercase font-heading rounded-avatar', {
  variants: {
    size: {
      lg: 'text-avatar-lg',
      xl: 'text-avatar-xl',
      '2xl': 'text-avatar-2xl',
      '3xl': 'text-avatar-3xl',
      '4xl': 'text-avatar-3xl',
      ctt: null
    }
  }
})

export type AvatarFallbackProps = VariantProps<typeof avatarFallbackVariants>
